import styled from "styled-components";

export const Footer = styled.small`
  grid-area: f;
  color: lightgray;
  font-size: 1vh;
  width: 100%;
  margin: 0 auto;
`;
